export default __webpack_public_path__ + "static/gatsby_create_git_repo-b5fb7eb4d661e9df4bedcc19dc604d76.png";